import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {ConfigService} from '../../services/config/config.service';
import {MatAutocompleteSelectedEvent, MatAutocompleteTrigger} from '@angular/material/autocomplete';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {

  @Output() queryEvent: EventEmitter<{ queryString: string, selectedFromAutocomplete: boolean }> = new EventEmitter();

  @Input() data: string = '';
  @Input() suggestion: boolean = false;

  @Input() layout: 'searchpage' | 'resultspage' = 'searchpage';

  @ViewChild(MatAutocompleteTrigger) autocomplete?: MatAutocompleteTrigger;
  suggests: any;
  selectedFromAutocomplete = false;
  constructor(private api: ApiService, private confs: ConfigService) {
  }

  search() {
    // TODO: questa lunghezza andrebbe messa nell'environment!
    if (this.data.length <= 1) {
      return;
    }
    
    this.queryEvent.emit({queryString: this.data, selectedFromAutocomplete: this.selectedFromAutocomplete});
    this.autocomplete?.closePanel();
  }

  selectSuggestion(selectedSuggestion: MatAutocompleteSelectedEvent) {
    this.data = selectedSuggestion.option?.value;
    this.selectedFromAutocomplete = true;
    
  }

  getSuggestions() {
    // Resettiamo lo status di selezione da autocomplete
    this.selectedFromAutocomplete = false;

    // Se l'autocomplete non è attivato, usciamo
    if (!this.confs.getConfig().activeteSuggestions && !this.suggestion) {
      return;
    }

    // Impostiamo una lunghezza minima della stringa da cercare
    // TODO: questa lunghezza andrebbe messa nell'environment!
    if (this.data.length <= 1) {
      this.suggests = [];
      return;
    }

    this.api.suggestion(this.data).subscribe({
      next: (res: any) => {
        this.suggests = res.data;
      },
      error: (err) => console.log(err)
    });
  }


}
